import React, { useState } from "react";
import AppLayout from "../layout";
import frame1 from "../assets/realisation/frame1.png";
import frame2 from "../assets/realisation/capture-portfolio.png";
import frame3 from "../assets/realisation/frame3.png";
import frame4 from "../assets/realisation/frame4.png";

import { BrowserView, MobileOnlyView } from "react-device-detect";
import { RealisationMobile } from "./mobile/realisation";
import { Button } from "antd";
import { SpaceVertical } from "../common/utils/spacing";
const Realisation = () => {
  return (
    <AppLayout>
      <BrowserView>
        <div className="realisations">
          <h1 className="title">MES REALISATIONS</h1>

          <div className="list-realisation">
            <OneRealisation
              title="CLONE INSTAGRAM"
              tech="Figma"
              date="2020"
              text="Reproduction de la partie 'UI UX' de l'apllication mobile Instagram en utilisant comme technologie Figma"
              image={frame1}
              link={`https://www.figma.com/proto/ttikA7ZMIh6WXdV6eYDgt9/Instagram?node-id=51%3A99&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=51%3A99&hide-ui=1`}
            />
            <OneRealisation
              title="MON PORTFOLIO"
              tech="React JS"
              date="2021"
              text="Développement de mon portfolio avec React Js"
              image={frame2}
              link="https://portfolio-hali.web.app/"
            />
            <OneRealisation
              title="Clone site Meta de Facebook"
              tech="React Js"
              date="2022"
              text="Clonage du site meta de facebook en utilisant comme technologie React Js"
              image={frame3}
              link="https://meta-site-28b7b.web.app/"
            />
            <OneRealisation
              title="FIGMA"
              tech="Figma"
              date="2022"
              text="Clonage du UI UX Design du site meta de facebook avec Figma"
              image={frame4}
              link={`https://www.figma.com/proto/8NqCF4kRbxxlQwbkOoDGdc/facebook-meta?node-id=1%3A2&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=98%3A4&hide-ui=1`}
            />
          </div>
        </div>
      </BrowserView>
      <MobileOnlyView>
        <RealisationMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const OneRealisation = ({ title, tech, date, text, image, link }) => {
  const [over, setOver] = useState(false);
  return (
    <a
      href={link}
      target="blank"
      className="one-realisation"
      onMouseEnter={() => setOver(true)}
      onMouseLeave={() => setOver(false)}
    >
      {over && (
        <div className="cover">
          <h1>{title}</h1>
          <h3>{`${tech} - ${date}`}</h3>
          <p>{text}</p>
          <SpaceVertical size={40} />
          <Button type="primary">En savoir plus</Button>
        </div>
      )}

      <div
        className="r-image"
        style={{
          backgroundImage: `url(${image})`,
          width: "100%",
          height: "100%",
        }}
      ></div>
    </a>
  );
};

export default Realisation;
